import { AutogenModelPnnBuilderSendto, AutogenRowPnnBuilderSendto } from "./autogen/AutogenModelPnnBuilderSendto";

export class ModelPnnBuilderSendto extends AutogenModelPnnBuilderSendto<RowPnnBuilderSendto> {
	constructor() {
		super(RowPnnBuilderSendto);
	}
}

export class RowPnnBuilderSendto extends AutogenRowPnnBuilderSendto {
}